import Grid from '@mui/material/GridLegacy';
import Typography from '@mui/material/Typography';

interface ErrorMessageProps {
    message: string;
    className: string;
}

export const ErrorMessage = ({ message, className }: ErrorMessageProps) => (
    <Grid className={className}>
        <Typography color="inherit" variant="body2">
            {message}
        </Typography>
    </Grid>
);
